import BroadComponentType from 'owa-bundling/lib/types/BroadComponentType';
import { ComponentGetter, ErrorHandlerConfigType, LazyLoadConfig } from '../schema/ErrorConfig';
import { LazyModule } from 'owa-bundling-light';
import { TraceErrorObject } from 'owa-trace';

export const getOwaLazyErrorConfig = <TProps, TModule, TInnerRef, TPlaceHolderRef = void>(
    lazyModule: LazyModule<TModule>,
    componentGetter: ComponentGetter<TModule, TProps, TInnerRef>,
    placeholder?: BroadComponentType<TProps, TPlaceHolderRef>,
    importErrorHandler?: (reason: any) => void,
    unhandledExceptionHandler?: (error: TraceErrorObject) => void
): LazyLoadConfig<TProps, TModule, TInnerRef, TPlaceHolderRef> => ({
    configType: ErrorHandlerConfigType.owaLazy,
    lazyModule,
    componentGetter,
    placeholder,
    importErrorHandler,
    unhandledExceptionHandler,
});
